module.exports = __webpack_public_path__ + "e9893f28e40e34c232fe35b1899ac287.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 149
// module chunks = 0